import React, { useState } from 'react';
import styles from './RadioGroup.module.scss';

const RadioGroup = ({ options, name, onSelect }) => {
  const [selectedValue, setSelectedValue] = useState(null);

  const handleSelect = (value) => {
    setSelectedValue(value);
    if (onSelect) {
      onSelect(value);
    }
  };

  return (
    <div className={styles.radioGroup}>
      {options.map((option) => (
        <div
          key={option.value}
          className={styles.radioItem}
          onClick={() => handleSelect(option.value)}
        >
          <div
            className={`${styles.radioCircle} ${selectedValue === option.value ? styles.selected : ''}`}
          ></div>
          <label className={styles.label}>{option.label}</label>
        </div>
      ))}
    </div>
  );
};

export default RadioGroup;
